import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import events from '@/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzCookieButton',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;


function openKlaro() {
    events.$emit('show', '');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    onClick: openKlaro,
    class: "cursor-pointer"
  }, _toDisplayString(_ctx.title), 1))
}
}

})